<div class="modal-header">
  <div class="row gap-1 d-flex align-items-center justify-content-between">
    <div class="col-1">
      <img [src]="icon" alt="img/default_entity.png" width="42" height="42" class="entity-window-icon">
    </div>
    <div class="col-10">
      <div class="details-name yellow-title">{{ mapEntity?.name }}</div>
      <div class="details-label">{{ formatDate(mapEntity?.timestamp) }}</div>
      @if (showStaticCoordinates()) {
        <div class="details-label">
          Lat: {{ round(mapEntity?.latitude) }} Lon: {{ round(mapEntity?.longitude) }}
        </div>
      }
      @if (showTemporalCoordinates()) {
        <div class="details-label">
          Lat: {{ round(tempLat) }} Lon: {{ round(tempLong) }}
        </div>
      }
    </div>
  </div>
</div>
<div class="detailsHeaderX" (click)="closeWindow()">×</div>
@if (!mapEntity?.isVisibleInLayersUI && mapEntity?.LIVE_MODE) {
  <div class="modal-body">
    <app-safezone-visualizer [mapEntity]="mapEntity"></app-safezone-visualizer>
  </div>
}